import {
  AdditionalInterest,
  Appointment,
  AppointmentV2,
  AppointmentType,
  AvailabilitySlot,
  BookingResponse,
  CulturalBackground,
  EditAppointment,
  Gender,
  GenderAttributeDetails,
  CulturalBackgroundAttributeDetails,
  AdditionalInterestAttributeDetails,
  OutputAppointmentTypePublic,
} from '@dialogue/timekeeper'
import { Practitioner } from '@dialogue/coredata'

export interface Provider extends Practitioner {
  bio?: string | null
  jobTitle?: string
}

export interface ProviderDetailsData {
  gender: Gender
  culturalBackgrounds: CulturalBackground[]
  additionalInterests: AdditionalInterest[]
  otherInterests: AdditionalInterest[] | null
  id: number
}

export interface ProviderDetails {
  loading: boolean
  error: Error | null
  data: null | ProviderDetailsData
}
export interface ProviderAttributes {
  genders: GenderAttributeDetails[]
  culturalBackgrounds: CulturalBackgroundAttributeDetails[]
  additionalInterests: AdditionalInterestAttributeDetails[]
}

export interface SelectedPreferences {
  genders: Gender[]
  cultural_backgrounds: CulturalBackground[]
  additional_interests: AdditionalInterest[]
}

export interface ProviderAvailabilitiesState {
  data: AvailabilitySlot[]
  loading: boolean
  error: Error | null
}

export interface ProviderBookingState {
  selectedDay: string | null
  availabilities: {
    data: AvailabilitySlot[]
    loading: boolean
    error: Error | null
  }
  providerAvailabilities: Record<number, ProviderAvailabilitiesState>
  createAppointmentRequest: {
    data: Appointment | AppointmentV2 | null
    loading: boolean
    error: Error | null
  }
  providers: {
    data: Record<number, Provider>
    loadingList: boolean
    loadingBio: boolean
    error: Error | null
  }
  attributes: {
    loading: boolean
    error: Error | null
    data: null | ProviderAttributes
  }
  providerDetails: {
    loading: boolean
    error: Error | null
    data: null | ProviderDetailsData
  }
  appointmentTypes: {
    data: OutputAppointmentTypePublic[]
    loading: boolean
    fetched: boolean
    error: Error | null
  }
  updateAppointmentRequest: {
    data: Appointment | null
    loading: boolean
    error: Error | null
  }
  booking: {
    data: BookingResponse | null
    loading: boolean
    error: Error | null
  }
  selectedProviderId: number | null
}

export interface GetAvailabilitiesParams {
  bookingId: string
  appointment_type: AppointmentType
  provider?: number[]
  start_at: string
  end_at: string
}

export interface GetProviderAvailabilitiesParams {
  bookingId: string
  providerId: number
  start_at: string
  end_at: string
}

export interface UpdateAppointmentParams {
  appointment_id: number
  member_id: number
  appointment: EditAppointment
}

export interface UpdateBookingParams {
  bookingId: string
  preferences: SelectedPreferences
}

export enum Attributes {
  GENDERS = 'genders',
  CULTURAL_BACKGROUNDS = 'cultural_backgrounds',
  ADDITIONAL_INTERESTS = 'additional_interests',
}
